import { darken } from 'polished';
import React from 'react';
import { LFC } from '../../../Legacy';
import { Matrix } from '../../../platform/geom/Matrix';
import { Colors } from '../../../ui';
import { RenderBounds, RenderBox, RenderInner, usePressable } from '../../canvas/visualization/RenderHelpers';
import { Buzzer } from './Buzzer';
import { BuzzerLayout } from './BuzzerLayout';

const RenderBorder: LFC<{ object: Buzzer }> = ({ object }) => {
    const { base } = object.layout;
    return <>
        <RenderBox
            {...base.toCSS()}
            background={Colors.white}
            borderRadius="50%"
            border={`solid 1px ${Colors.border}`}
            borderBottom={`solid 3px ${Colors.border}`}
        />
    </>;
};

const RenderButton = React.memo<{ layout: BuzzerLayout, color: string, interaction: string }>(({ layout, color, interaction }) => {
    color = Colors.normalize(color) ?? Colors.red700;
    const { buzz } = layout;

    const transform =
        (interaction === 'idle' ? Matrix.translate(0, -6).toCSS() : null) ??
        (interaction === 'hover' ? Matrix.translate(0, -10).toCSS() : null) ??
        (interaction === 'active' ? Matrix.translate(0, -2).toCSS() : null);

    const foreStyle = {
        ...buzz.toCSS(),
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        border: `solid 4px ${darken(.1, color)}`,
        borderRadius: '50%',
        background: color,
        transform,
        transition: 'transform 75ms ease-out',
    };

    const backStyle = {
        ...buzz.toCSS(),
        borderRadius: '50%',
        background: darken(.1, color),
    };

    return <>
        <RenderBox {...backStyle} />
        <RenderBox {...foreStyle}>

        </RenderBox>
    </>;
});

export const BuzzerVisual: LFC<{ object: Buzzer }> = ({ object, children }) => {

    const buzz = usePressable(object, 'buzz');

    return <>
        <RenderBounds object={object}>
            <RenderInner object={object}>
                <RenderBorder object={object} />
                <RenderButton layout={object.layout} color={object.color} interaction={buzz} />
            </RenderInner>
        </RenderBounds>

    </>;
};
